import { FormField } from "./form-field.js";

/**
 * TextField — single-line text/number/email input. `onInput(value, event)`
 * fires on every keystroke (for live validation); callers debounce/validate
 * on their own schedule (e.g. on blur or submit), this component doesn't
 * guess that for them.
 */
export function TextField({
  id,
  label,
  type = "text",
  value = "",
  placeholder,
  hint,
  error,
  required = false,
  min,
  max,
  step,
  onInput,
}) {
  const input = document.createElement("input");
  input.type = type;
  input.id = id;
  input.name = id;
  input.className = "form-control";
  input.value = value;
  if (placeholder) input.placeholder = placeholder;
  if (min !== undefined) input.min = String(min);
  if (max !== undefined) input.max = String(max);
  if (step !== undefined) input.step = String(step);
  if (error) input.classList.add("form-control-error");

  if (onInput) {
    input.addEventListener("input", () => onInput(input.value, input));
  }

  return FormField({ id, label, required, hint, error, control: input });
}
